// src/components/onboarding/OnboardingSection.jsx
import React from "react";
import { cn } from "@/utils/cn";

export default function OnboardingSection({
  header,
  children,
  footer,
  center = false,
  headerClassName = "",
  bodyClassName = "",
  footerTab = false,
  rootClassName = "",
  footerShellClassName = "",
  footerHeight = 96, // px
}) {
  return (
    <div
      className={cn("min-h-dvh flex flex-col", rootClassName)}
      style={{
        ["--onb-footer-h"]: footer ? `${footerHeight}px` : "0px",
      }}
    >
      {/* SCROLL AREA */}
      <div className="flex-1 overflow-y-auto">
        <div className="relative z-0 afrimed-rail afrimed-rail--comfortable">
          {/* Header spacing */}
          {header ? (
            <div className={cn("pt-5 sm:pt-6 pb-4 sm:pb-5", headerClassName)}>
              {header}
            </div>
          ) : (
            // ✅ For centered “success / done” screens, remove the top spacer so it can be truly centered
            <div className={cn(center ? "pt-0" : "pt-5 sm:pt-6")} />
          )}

          {/* Body */}
          <div
            className={cn(
              center ? "flex min-h-[45vh] flex-col items-center justify-center" : "",
              // ✅ Critical: footer padding shifts visual centering upward.
              // Only apply the big footer-safe padding when NOT centering.
              !center
                ? "pb-[calc(var(--onb-footer-h)+env(safe-area-inset-bottom)+16px)]"
                : "pb-0",
              bodyClassName
            )}
          >
            {children}
          </div>
        </div>
      </div>

      {/* STICKY FOOTER */}
      {footer ? (
        <div className={cn("sticky bottom-0 z-30 w-full", footerShellClassName)}>
          <div className="afrimed-rail afrimed-rail--comfortable">
            <div
              className={cn(
                "w-full",
                footerTab &&
                  "bg-[rgb(var(--clr-surface-cont-highest))] shadow-[0_-8px_24px_rgba(15,23,42,0.08)]",
                "pt-2 pb-3 mb-[env(safe-area-inset-bottom)]"
              )}
            >
              <div className="w-full mx-auto max-w-[560px] px-3 md:px-0">
                <div className="flex flex-col gap-3 items-stretch">{footer}</div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
